import i18n from '@config/i18n/i18n'

export default {
  state: {
    locales: ['it', 'en']
  },
  mutations: {
    changeLocale(state, lang) {
      i18n.locale = lang
      localStorage.setItem('currentLocale', lang)
    },
  },
  getters: {
    getLocales: state => {
      return state.locales
    }
  }
}